/*
 * 定制直播间枚举
 * /marketing/wx/v1/public/config [customZb字段]
 * */
export const CUSTOM_LIVE = {
  1: 'ZHONG_YAN', // 中烟
  2: 'KA_TE', // 卡特
  1620605380: 'TANG_CHEN_BEI_JIAN', // 汤臣倍健
  1715950120: 'CHANG_HONG', // 长虹
  // /api/live/customconfig [customize字段]
  guanxizhongyan: 'ZHONG_YAN', // 中烟
  kate: 'KA_TE', // 卡特
  lianbang: 'LIAN_BANG'
}
